import PATH from 'routes/path';

const HelpNavList = [
  {
    title: 'Request a Sample',
    path: `${PATH.REQUEST_A_SAMPLE}`
  },
  {
    title: 'Help',
    path: `${PATH.HELP}`
  },
  {
    title: 'Contact',
    path: `${PATH.CONTACT}`
  }
];

export default HelpNavList;
